import React from 'react';
import { useSelector } from 'react-redux';
import { TypographyWhitespacePreWrap } from 'component/page/detail/Itineraries/StructuredItinerary/ItineraryStep';
import { selectActivityContentLocale, selectActivityDescription } from 'component/page/detail/store/detail.selectors';

const UnstructuredItinerary: React.FC = () => {
    const itineraryDesc = useSelector(selectActivityDescription);
    const contentLocale = useSelector(selectActivityContentLocale);

    if (!itineraryDesc) {
        return null;
    }

    return (
        <TypographyWhitespacePreWrap
            tag="h3"
            data-testid="detail-itinerary-unstructured"
            variant="body-s"
            role="heading"
            aria-level={3}
            textColor="base.subtle"
            py="12"
            px="0"
            lang={contentLocale}
        >
            {itineraryDesc}
        </TypographyWhitespacePreWrap>
    );
};
UnstructuredItinerary.displayName = 'UnstructuredItinerary';

export default UnstructuredItinerary;
